import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { ApexAxisChartSeries, ApexChart, ApexNonAxisChartSeries, ApexResponsive, ApexXAxis } from "ng-apexcharts";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { AuthenticationService } from "src/app/_services/authenticationService";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
};

export type DonutChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
};

@Component({
  selector: "app-supplier-home",
  templateUrl: "./supplier-home.component.html",
  styleUrls: ["./supplier-home.component.scss"],
})
export class SupplierHomeComponent implements OnInit {
  displayName: any;
  responseData: any;
  responseDataPO: any;
  stats: any;
  statsInternal: any;
  statsInternalPo: any;
  chartDataPo = false;
  chartDataInvoice = false;
  sessionExpired = false;
  isError = false;
  errorMsg = "";
  public chartOptions: Partial<ChartOptions> | any;
  public donutChartOptions: Partial<DonutChartOptions> | any;
  data = false;
  loading = true;
  refreshInternalAnalytics = false;
  refreshPo = false;
  refreshAnalytics = false;
  openMobileMenu: boolean = false;
  username = "";
  isCondensed: boolean = false;
  internalError = false;
  externalError = false;
  // currentLayout = {
  //     isCondensed: true,
  // };
  onboardingStatus: any;
  pwChangeMsg = "";
  onboardingSucessMsg = "";
  passwordSet: any;
  onboadingSet: any;

  constructor(private http: HttpClient, private authService: AuthService, private authenticationService: AuthenticationService, private router: Router) {}

  // toggleSidebar() {
  //     this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
  //     document.body.setAttribute(
  //         "data-sidebar-size",
  //         this.currentLayout.isCondensed ? "condensed" : "default"
  //     );
  // }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  refreshInternalStats() {
    this.refreshInternalAnalytics = true;
    const userData = {
      action: "list",
      type: "invoice",
      filters: {
        vendor: [localStorage.getItem("vendorCode")],
        barcode: [],
        companyCode: [],
        location: [],
        poNo: [],
        irn: [],
        status: [],
        dateSubmitted: "",
        paymentDueDate: "",
        paymentDate: "",
        invoiceType: [],
      },
      email: "",
      sellerCode: localStorage.getItem("vendorCode"),
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.authService.fetchInvoice_Analytics(userData).subscribe(
      (res) => {
        this.loading = false;
        this.refreshInternalAnalytics = false;
        this.responseData = res;

        if (this.responseData.success || this.responseData.data.length !== 0) {
          this.statsInternal = this.responseData.data;
          if (
            this.statsInternal.approved_invoices.number === 0 &&
            this.statsInternal.in_processing_invoices.number === 0 &&
            this.statsInternal.paid_invoices.number === 0 &&
            this.statsInternal.rejected_invoices.number === 0 &&
            this.statsInternal.number_invoices.number === 0
          ) {
            this.chartDataInvoice = false;
          } else {
            this.chartDataInvoice = true;
          }
          this.chartOptions = {
            series: [
              {
                name: "Invoices",
                data: [
                  {
                    x: "Invoices posted and ready for payment",
                    y: this.statsInternal.approved_invoices.number,
                  },
                  {
                    x: "Invoices received and are in processing at JSW",
                    y: this.statsInternal.in_processing_invoices.number,
                  },
                  {
                    x: "Invoices Paid",
                    y: this.statsInternal.paid_invoices.number,
                  },
                  {
                    x: "Invoices Rejected",
                    y: this.statsInternal.rejected_invoices.number,
                  },
                ],
              },
            ],
            chart: {
              height: 250,
              type: "bar",
            },
            plotOptions: {
              bar: {
                distributed: true,
              },
            },
            legend: {
              show: true,
              position: "bottom",
            },
            colors: ["#18479f", "#a3a1fb", "#18c984", "#ff1f3e"],
            xaxis: {
              type: "category",
              categories: ["Processed Invoices", "Invoices in Process", "Paid Invoices", "Rejected Invoices"],
              labels: {
                show: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            yaxis: {
              show: true,
              tooltip: {
                enabled: true,
              },
            },
            tooltip: {
              fixed: {
                enabled: true,
                position: "topRight",
                offsetX: 0,
                offsetY: 0,
              },
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box">' + "<span>" + w.globals.seriesX[seriesIndex][dataPointIndex] + "</span>" + "</div>";
              },
            },
          };

          if (this.statsInternal.accepted_invoices.number) {
            this.chartOptions.series[0].data.push({
              x: "Invoices Accepted",
              y: this.statsInternal.accepted_invoices.number,
            });
            this.chartOptions.xaxis.categories.push("Invoices Accepted");
            this.chartOptions.colors.push("#00FF7F");
          }
          if (this.statsInternal.posted_invoices.number) {
            this.chartOptions.series[0].data.push({
              x: "Invoices Posted",
              y: this.statsInternal.posted_invoices.number,
            });
            this.chartOptions.xaxis.categories.push("Invoices Posted");
            this.chartOptions.colors.push("#9370DB");
          }
          if (this.statsInternal.rejected_invoices.number) {
            this.chartOptions.series[0].data.push({
              x: "Invoices Rejected",
              y: this.statsInternal.rejected_invoices.number,
            });
            this.chartOptions.xaxis.categories.push("Invoices Rejected");
            this.chartOptions.colors.push("#FF7F50");
          }
          if (this.statsInternal.submitted_invoices.number) {
            this.chartOptions.series[0].data.push({
              x: "Invoices Rejected",
              y: this.statsInternal.submitted_invoices.number,
            });
            this.chartOptions.xaxis.categories.push("Invoices Submitted");
            this.chartOptions.colors.push("#B0E0E6");
          }
        } else {
          this.loading = false;
          this.isError = true;
          this.internalError = true;
          this.data = false;
          this.chartDataInvoice = false;
          this.chartDataPo = false;
        }
      },
      (error) => {
        this.loading = false;
        this.internalError = true;
        this.chartDataInvoice = false;
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );

    this.authService.fetchPo_Analytics(userData).subscribe(
      (res) => {
        this.loading = false;
        this.refreshInternalAnalytics = false;
        this.responseDataPO = res;

        if (this.responseDataPO.success || this.responseDataPO.data.length !== 0) {
          this.statsInternalPo = this.responseDataPO.data[0];

          if (this.statsInternalPo.fully_invoiced_po_number === 0 && this.statsInternalPo.non_invoiced_po_number === 0 && this.statsInternalPo.partially_invoiced_po_number === 0) {
            this.chartDataPo = false;
          } else {
            this.chartDataPo = true;
          }

          this.donutChartOptions = {
            series: [this.statsInternalPo.fully_invoiced_po_number, this.statsInternalPo.partially_invoiced_po_number, this.statsInternalPo.non_invoiced_po_number],

            chart: {
              height: 295,
              type: "donut",
            },
            colors: ["#18479f", "#a3a1fb", "#9acce4"],
            labels: ["Fully Invoiced POs", "Partially Invoiced POs", "Non-Invoiced POs"],
            legend: {
              show: true,
              position: "bottom",
            },
            dataLabels: {
              enabled: true,
              formatter: function (val: any, opts: any) {
                return opts.w.config.series[opts.seriesIndex];
              },
            },
            tooltip: {
              enabled: true,
              custom: function ({ series, seriesIndex, w }) {
                let text = "";

                if (w.globals.labels[seriesIndex] === "Fully Invoiced POs") {
                  text = "Complete PO consumed and Invoices Submitted.";
                } else if (w.globals.labels[seriesIndex] === "Partially Invoiced POs") {
                  text = "Partial PO Value consumed and Invoices submitted.";
                } else {
                  text = "No invoice submitted against these POs.";
                }

                return '<div class="arrow_box">' + "<span>" + text + "</span>" + "</div>";
              },
            },
          };
        } else {
          this.loading = false;
          this.isError = true;
          this.internalError = true;
          this.data = false;
          this.chartDataInvoice = false;
          this.chartDataPo = false;
        }
      },
      (error) => {
        this.loading = false;
        this.internalError = true;
        this.chartDataInvoice = false;
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  refreshExternalStats() {
    this.refreshAnalytics = true;
    const userData = {
      sellerCode: localStorage.getItem("vendorCode"),
      emailId: localStorage.getItem("vendorEmail"),
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.authService.fetchExternalAnalytics(userData).subscribe(
      (res) => {
        this.loading = false;
        this.refreshAnalytics = false;
        this.responseData = res;
        if (this.responseData.success) {
          this.stats = this.responseData.data.RESPONSE;
        } else {
          this.loading = false;
          this.externalError = true;
          this.isError = true;
          this.data = false;
          this.refreshAnalytics = true;
        }
      },
      (error) => {
        this.refreshAnalytics = false;
        this.externalError = true;
        this.loading = false;
        this.isError = true;
        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  ngOnInit(): void {
    this.loading = true;
    this.displayName = localStorage.getItem("displayName");

    this.onboardingStatus = this.authService.getOnboardingStatus();
    this.pwChangeMsg = "Password changed successfully.";
    this.onboardingSucessMsg = "Account activated successfully.";

    this.passwordSet = true;
    this.onboadingSet = false;

    setTimeout(() => {
      this.passwordSet = false;
      this.onboadingSet = true;
    }, 4000);

    setTimeout(() => {
      this.onboardingStatus = false;
    }, 8000);

    //console.log(this.onboardingStatus);

    const userData = {
      action: "list",
      email: "",
      sellerCode: localStorage.getItem("vendorCode"),
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.refreshInternalStats();
    this.refreshExternalStats();
  }
}
